import React from 'react';

import { useCustomHeaderPresenter } from './CustomHeader.presenter';
import * as S from './CustomHeader.styles';

export const CustomHeader = (props) => {
  const {
    date,
    selected,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    changeMonth,
    changeYear,
  } = props;

  const presenter = useCustomHeaderPresenter({
    date,
    selected,
    changeMonth,
    changeYear,
    decreaseMonth,
    increaseMonth,
  });

  return (
    <S.Container>
      <S.Title>{presenter.title}</S.Title>
      <S.MonthsIconsContainer>
        <S.PrevMonthButton onClick={presenter.decreaseMonth} disabled={prevMonthButtonDisabled} />
        <S.NextMonthButton onClick={presenter.increaseMonth} disabled={nextMonthButtonDisabled} />
      </S.MonthsIconsContainer>
    </S.Container>
  );
};
